"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateFlattenNestedKeyObject = void 0;
const error_1 = require("../error");
const internalFlattenObjectByKey = (obj, { joinKey, manageArrayValue, allowAmbiguousKey, }, prefixArr, seenKeys) => {
    const inputs = {};
    for (const [key, value] of Object.entries(obj)) {
        const typeofKey = typeof key;
        (0, error_1.finleyAssert)(typeofKey === 'string', `Trying to flatten non-string key [key:${key}] [type:${typeofKey}]`);
        // a key can be ambiguous in the sense that it includes the join key within the path
        // which means the response from this method cannot be safely re-nested
        // {
        //   foo: {
        //          bar: 1
        //        }
        //   }
        //  => resolves to foo.bar: 1
        //  and
        //  {
        //    foo.bar: 1
        //  }
        // also resolves to foo.bar : 1
        if (!allowAmbiguousKey) {
            (0, error_1.finleyAssert)(!key.includes(joinKey), `[key:${key}] already incorrectly includes [joinKey:${joinKey}]`);
        }
        // Can revisit below assertion when this util needs to consider these scenarios
        const typeofValue = typeof value;
        (0, error_1.finleyAssert)(!['function', 'bigint', 'symbol'].includes(typeofValue), `${typeofValue} is not supported as flattened values [key:${key}]`);
        if (Array.isArray(value)) {
            (0, error_1.finleyAssert)(manageArrayValue !== 'error', `Arrays are not allowed as flattened values [key:${key}] [value:${value}]`);
            if (manageArrayValue === 'ignore') {
                continue;
            }
        }
        prefixArr.push(key);
        // Note: `null` and `arrays` are "object's" so also need to verify
        // If avoiding arrays, this would have exited already per above
        if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
            const flattenedObject = internalFlattenObjectByKey(value, { joinKey, manageArrayValue, allowAmbiguousKey }, prefixArr, seenKeys);
            for (const [flattenedKey, flattenedValue] of Object.entries(flattenedObject)) {
                inputs[flattenedKey] = flattenedValue;
            }
        }
        else {
            const flattenedKey = prefixArr.join(joinKey);
            (0, error_1.finleyAssert)(!seenKeys.has(flattenedKey), `Duplicated flattened key detected [key:${flattenedKey}]. Flattened keys must be unique to prevent overwrite.`);
            seenKeys.add(flattenedKey);
            inputs[flattenedKey] = value;
        }
        prefixArr.pop();
    }
    return inputs;
};
/**
 * allowAmbiguousKey = true allows the keys in the obj
 * to include joinKey.  The impliciations of this being set to true
 * is that the caller can not longer safely nest the return object.  If
 * being able to re-nest after calling this, allowAmbigousKey should be set to false (default)
 */
const generateFlattenNestedKeyObject = (obj, { joinKey = '.', manageArrayValue = 'error', allowAmbiguousKey = false, } = {}) => {
    return internalFlattenObjectByKey(obj, { joinKey, manageArrayValue, allowAmbiguousKey }, [], new Set());
};
exports.generateFlattenNestedKeyObject = generateFlattenNestedKeyObject;
//# sourceMappingURL=generateFlattenNestedKeyObject.js.map